import { useNavigate } from 'react-router-dom'
import { BrowserView, MobileView } from 'react-device-detect'
import { Col, Row } from 'react-bootstrap'
import { Fade } from 'react-awesome-reveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHammer, faHandshake, faHeart, faLeaf, faUserGraduate } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Home/HomeGoal.css'
import homeGoal_1 from '../../assets/images/home/home-goal-1.jpg'
import homeGoal_2 from '../../assets/images/home/home-goal-2.jpg'
import homeGoal_3 from '../../assets/images/home/home-goal-3.jpg'
import homeGoal_4 from '../../assets/images/home/home-goal-4.jpg'
import homeGoal_5 from '../../assets/images/home/home-goal-5.jpg'

function HomeGoal() {

    const navigate = useNavigate()

    const goals = [
        {
            left: {
                id: 1,
                idName: 'homeGoal-1',
                title: "Humanitaire",
                titleIcon: <FontAwesomeIcon icon={faHandshake} className='homeGoalColIcon' />,
                link: "/objectifs/aide-humanitaire",
                image: homeGoal_1
            },
            right: {
                id: 2,
                idName: 'homeGoal-2',
                title: "Santé",
                titleIcon: <FontAwesomeIcon icon={faHeart} className='homeGoalColIcon' />,
                link: "/objectifs/santé",
                image: homeGoal_2
            }
        }, {
            left: {
                id: 3,
                idName: 'homeGoal-3',
                title: "Construction",
                titleIcon: <FontAwesomeIcon icon={faHammer} className='homeGoalColIcon' />,
                link: "/objectifs/habitat-construction",
                image: homeGoal_3
            },
            right: {
                id: 4,
                idName: 'homeGoal-4',
                title: "Éducation",
                titleIcon: <FontAwesomeIcon icon={faUserGraduate} className='homeGoalColIcon' />,
                link: "/objectifs/éducation",
                image: homeGoal_4
            }
        }, {
            left: {
                id: 5,
                idName: 'homeGoal-5',
                title: "Développement durable",
                titleIcon: <FontAwesomeIcon icon={faLeaf} className='homeGoalColIcon' />,
                link: "/objectifs/développement-durable",
                image: homeGoal_5
            }
        }
    ]

    return (

        <>
            <BrowserView>
                <div className='homeGoal'>
                    <div className='homeSectionTitle'>Nos objectifs</div>
                    {goals.map((item) => {
                        return (
                            <Row key={item.left.id} className='homeGoalRow'>
                                {item.left ?
                                    <Col sm={6} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate(item.left.link) }}>
                                        <Fade direction={'left'} duration={500}>
                                            <div className='homeGoalColLeft'>
                                                <img src={item.left.image} className='homeGoalColImage' alt="test" />
                                            </div>
                                            <div className='homeGoalColText'>
                                                {item.left.titleIcon}{item.left.title}
                                            </div>
                                        </Fade>
                                    </Col>
                                    :
                                    <Col sm={6}></Col>
                                }
                                {item.right ?
                                    <Col sm={6} onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate(item.right.link) }}>
                                        <Fade direction={'right'} duration={500}>
                                            <div className='homeGoalColRight'>
                                                <img src={item.right.image} className='homeGoalColImage' alt="test" />
                                            </div>
                                            <div className='homeGoalColText'>
                                                {item.right.titleIcon}{item.right.title}
                                            </div>
                                        </Fade>
                                    </Col>
                                    :
                                    <Col sm={6}></Col>
                                }
                            </Row>
                        )
                    })}
                </div>
            </BrowserView>

            <MobileView>
                <div className='homeGoalMobile'>
                    <div className='homeSectionTitle'>Nos objectifs</div>
                    {goals.map((item) => {
                        return (
                            <div key={item.left.id}>
                                <Row className='homeGoalRow'>
                                    <Col onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate(item.left.link) }}>
                                        {item.left ?
                                            <Fade direction={'left'} duration={500}>
                                                <div className='homeGoalColTextMobile'>
                                                    {item.left.titleIcon}{item.left.title}
                                                </div>
                                                <div className='homeGoalColLeftMobile'>
                                                    <img src={item.left.image} className='homeGoalColImage' alt="test" />
                                                </div>
                                            </Fade>
                                            : null
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col onClick={() => { window.scrollTo({ top: 0, behavior: 'instant' }); navigate(item.right.link) }}>
                                        {item.right ?
                                            <Fade direction={'right'} duration={500}>
                                                <div className='homeGoalColTextMobile'>
                                                    {item.right.titleIcon}{item.right.title}
                                                </div>
                                                <div className='homeGoalColRightMobile'>
                                                    <img src={item.right.image} className='homeGoalColImage' alt="test" />
                                                </div>
                                            </Fade>
                                            : null
                                        }
                                    </Col>
                                </Row>
                            </div>
                        )
                    })}
                </div>
            </MobileView>
        </>

    )

}

export default HomeGoal
